import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { RouterLink, Router, NavigationEnd } from '@angular/router';
import { Subject, takeUntil, Observable, from, filter, concatMap } from 'rxjs';
import { NotificationDropdownComponent } from 'src/app/features/notifications/notification-dropdown/notification-dropdown.component';
import { CustomButtonDto } from 'src/app/shared/components/app-button/app-button-dto';
import { AppButtonComponent } from 'src/app/shared/components/app-button/app-button.component';
import { StyleContentHeader } from 'src/app/shared/models/styleContent';
import { UserModel } from 'src/app/shared/models/userModel';
import { ReplaceTextPipe } from 'src/app/shared/pipe/replace-text.pipe';
import { ActiveSectionsService } from '../../services/active-sections.service';
import { AlertService, AlertType } from '../../services/alert.service';
import { FileService } from '../../services/file.service';
import { HeaderService } from '../../services/header.service';
import { MemberService } from '../../services/member.service';
import { NotificationsService } from '../../services/notifications.service';
import { UserService } from '../../services/user.service';
import { UserDropdownComponent } from '../header/user-dropdown/user-dropdown.component';
import { UserSideBarComponent } from '../header/user-side-bar/user-side-bar.component';
import { LogoTextComponent } from '../logo-text/logo-text.component';
import { Notification } from 'src/app/shared/models/notificationsModel';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-header-ceara',
  standalone: true,
  imports: [
    CommonModule,
    AppButtonComponent,
    LogoTextComponent,
    RouterLink,
    UserDropdownComponent,
    NotificationDropdownComponent,
    UserSideBarComponent,
    ReplaceTextPipe
  ],
  templateUrl: './header-ceara.component.html',
  styleUrl: './header-ceara.component.scss'
})
export class HeaderCearaComponent implements OnInit, OnDestroy {
  @ViewChild(NotificationDropdownComponent)
  notificationsDropdown!: NotificationDropdownComponent;

  private authService = inject(AuthService);
  isLoggedIn = toSignal(this.authService.isLoggedIn, { initialValue: false });
  isDependent = toSignal(this.authService.isDependent, { initialValue: false });
  isHome = input<boolean>();

  userInfo: UserModel;

  get hasUserInfo() {
    if (!this.userInfo) {
      return 0;
    }

    return Object.keys(this.userInfo)?.length;
  }

  headerItems = computed<any[]>(() => {
    this.selectedMenuItem = '';

    const hasMenuEveryOne = localStorage.getItem('menuEveryoneCard') ? localStorage.getItem('menuEveryoneCard') : false;
    const labelMenuEveryOne = localStorage.getItem('labelEveryoneCard') ? localStorage.getItem('labelEveryoneCard') : 'Cartão de Todos';
    const labelPartners = localStorage.getItem('labelPartners') && localStorage.getItem('labelPartners') !== 'true'
      ? localStorage.getItem('labelPartners')?.toUpperCase().replace(/"/g, '')
      : 'PARCEIROS';

    const url = window.location.href.toLowerCase();
    const hasVitoria = url.includes('vitoria');
    const hasCeara = url.includes('ceara') || url.includes('sociovozao');

    if (this.isDependent()) {
      return [];
    } else if (this.isLoggedIn() && hasMenuEveryOne) {
      return [
        { name: 'INGRESSOS', id: 'ingressos' },
        { name: 'EXPERIÊNCIAS', id: 'experiencias' },
        { name: labelPartners, id: 'parceiros' },
        { name: 'LEÃO DE VANTAGENS', id: 'leao' },
        { name: 'TRANSPARÊNCIA', id: 'transparencia' },
        { name: 'RANKING', id: 'ranking' },
        {
          name: hasVitoria ? 'TV VITÓRIA+' : hasCeara ? 'VOZÃO TV' : 'EXCLUSIVO',
          id: 'exclusivo'
        },
        { name: labelMenuEveryOne?.toUpperCase(), id: 'cartao-todos' },
      ];
    } else if (this.isLoggedIn()) {
      return [
        { name: 'INGRESSOS', id: 'ingressos' },
        { name: 'EXPERIÊNCIAS', id: 'experiencias' },
        { name: labelPartners, id: 'parceiros' },
        { name: 'LEÃO DE VANTAGENS', id: 'leao' },
        { name: 'TRANSPARÊNCIA', id: 'transparencia' },
        { name: 'RANKING', id: 'ranking' },
        {
          name: hasVitoria ? 'TV VITÓRIA+' : hasCeara ? 'VOZÃO TV' : 'EXCLUSIVO',
          id: 'exclusivo'
        },
      ];
    } else {
      return [
        { name: 'PLANOS', id: 'planos' },
        { name: 'INGRESSOS', id: 'ingressos' },
        { name: 'EXCLUSIVO', id: 'exclusivo' },
        { name: 'BENEFÍCIOS', id: 'beneficios' },
        { name: 'POLÍTICA DE BIOMETRIA', id: 'facial' },
        { name: 'RANKING', id: 'ranking' },

      ];
    }
  });

  notifications: Notification[] = [];

  menuItems = computed<any[]>(() => {
    const sections = this.activeSections();
    if (!sections) return [];
    return this.headerItems().filter(item => sections[item.id]);
  });

  logoUrl: string = '';
  backgroundColor: string = '';
  textColor: string = '';
  buttonStyles: { [key: string]: string } = {};
  menuStyles: { [key: string]: string } = {};
  importantStyles: any = null;
  logoStyles: any = null;

  private _destroy$ = new Subject<void>();

  buttonGonnaBePartnerOptions: CustomButtonDto;

  buttonLoginOptions: CustomButtonDto;
  setFromHeader = false;

  selectedMenuItem = '';
  currentUrl = '';
  isBlocked = localStorage.getItem('enablePortal') === 'false';
  isSecondaryPlan = localStorage.getItem('isSecondaryPlan') === 'true';
  userBlocked = false;
  activeSections = signal<any>(null);
  activeSectionsSearched = false;
  clubSocialNetwork: any[];
  clubData = JSON.parse(localStorage.getItem('socialNetworks') as string);

  constructor(
    private router: Router,
    private notificationService: NotificationsService,
    private alertService: AlertService,
    private headerService: HeaderService,
    private fileService: FileService,
    private userService: UserService,
    private activeSectionsService: ActiveSectionsService,
    private memberService: MemberService
  ) {
    this.getActiveSections();

    // Carrega as notificações ao entrar na aplicação
    this.userService.currentUser.subscribe((user) => {
      const userChanged = this.userInfo?.id !== user?.id;
      this.userInfo = user as UserModel;
      this.isSecondaryPlan = localStorage.getItem('isSecondaryPlan') === 'true';
      if (userChanged) {
        this.notifications = [];
      }
      if (this.userInfo && this.notifications.length == 0) {
        this.loadNotifications();
      }
      this.userBlocked =
        !this.isSecondaryPlan &&
        (!this.userInfo?.memberPlans?.length ||
          this.memberService.isMemberSituationInEnum(
            this.userInfo?.memberSituation?.id as string
          ) ||
          this.userInfo?.memberSituation?.name == 'Inadimplente');
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Check for NavigationEnd event
        this.currentUrl = event.urlAfterRedirects; // Access the full URL after redirects

        this.resetNavSelection(this.currentUrl);
      }
    });
  }

  ngOnInit(): void {
    this.setHeaderStyle();

    // Escuta mudanças na pagina de lista de notificações e atualiza o header de acordo
    this.notificationService.updateNotificationSubject
      .pipe(takeUntil(this._destroy$))
      .subscribe((resp: Notification[]) => {
        if (!this.setFromHeader) {
          this.notifications = resp;
        }
        this.setFromHeader = false;
      });

    console.log(this.headerItems())
  }

  public loadNotifications(): any {
    const cpf = this.userInfo?.cpf;
    const memberId = this.userInfo?.id;
    if (!cpf || !memberId) return new Observable<Notification[]>();
    this.notificationService.getAllNotifications(cpf, memberId).subscribe({
      next: (res: any) => {
        // Descarta resposta atrasada de um usuário anterior (troca de login sem refresh)
        if (this.userInfo?.id !== memberId) return;
        let notifications = this.orderByUnread(res);
        this.notifications = notifications;
      },
    });
  }

  private resetNavSelection(url: string, clickOnLogo = false): void {
    const onHeaderNavItems =
      url.includes('check-in') ||
      url.includes('experiencias') ||
      url.includes('cartao-todos') ||
      url.includes('parcerias') ||
      url.includes('transparencia') ||
      url.includes('ranking-de-socios') ||
      url.includes('conteudo-exclusivo');

    if ((!this.isLoggedIn() && url !== '/') || clickOnLogo) {
      this.selectedMenuItem = '';
    } else if (this.isLoggedIn() && !onHeaderNavItems) {
      this.selectedMenuItem = '';
    }
  }

  private setHeaderStyle(): void {
    this.headerService.getHeader().subscribe({
      next: (res: StyleContentHeader) => {
        const styles = res;

        this.setElementsStyles(styles);
        this.setBtnStyles(styles);
      },
    });

    this.clubSocialNetwork = this.clubData?.map((network: any) => ({
      class: `bi bi-${network.name.toLowerCase()}`,
      href: network.url
    }));
  }

  setElementsStyles(styles: StyleContentHeader): void {
    if (!styles) {
      return;
    }

    this.menuStyles = {
      '--menu-font-size': styles.memberCountTextSize + 'px',
      '--menu-color-item': styles.menuItemColor,
      '--menu-color-item-hover': styles.menuItemHoverColor,
      '--menu-color-item-selected': styles.menuItemSelectedColor,
      '--menu-color-item-disabled': '#ccc',
      '--menu-background-color': styles.menuBackgroundColor,
      '--header-background-color': styles.menuBackgroundColor,
      '--button-color-hover': styles.buttonColorWhenHovering,
      '--button-color-text-hover': styles.buttonTextColorWhenHovering,
      '--button-color-text': styles.buttonTextColor,
      '--button-border': styles.buttonBorderColor,
      '--button-border-enter': styles.buttonBorderColorEnter,
      '--button-color-text-enter': styles.buttonTextColorEnter,
      '--button-color-hover-enter': styles.buttonColorWhenHoveringEnter,
      '--button-color-text-hover-enter':
        styles.buttonTextColorWhenHoveringEnter,
      '--button-color': styles.buttonColor,
      '--button-color-enter': styles.buttonColorEnter,
    };

    const prefixText = styles.memberNumberPhrases?.filter(
      (phrase: any) => phrase.inUse
    )[0]?.phrase;
    const docDownloadUrl = this.fileService.getDocDownloadUrl(
      styles.imageLogo?.id
    );
    this.logoStyles = {
      url: docDownloadUrl || localStorage.getItem('imageLogo') || '',
      style: `color: ${styles.menuItemColor} !important; font-size: ${styles.memberCountTextSize}px !important;`,
      prefixText: prefixText,
      '--primaryColor': styles.buttonColor,
      '--secondaryColor': styles.secondaryColor,
      '--prefixColor': styles.memberPhrasesTextColor,
      '--highlightedColor': styles.highlightedColor,
      '--suffixColor': styles.suffixColor,
      '--prefixWeight': styles.prefixWeight,
      '--highlightedWeight': styles.highlightedWeight,
      '--suffixWeight': styles.suffixWeight,
      '--prefixSize': styles.prefixSize,
      '--highlightedSize': styles.highlightedSize,
      '--suffixSize': styles.suffixSize,
    };
  }

  setBtnStyles(styles: StyleContentHeader): void {
    if (!styles) {
      return;
    }

    this.buttonGonnaBePartnerOptions = {
      primaryColor: 'transparent',
      secondaryColor: styles.secondaryColor,
      buttonText: styles.buttonTextLabel ? styles.buttonTextLabel.toUpperCase() : 'QUERO SER SÓCIO',
      buttonTextColor: styles.buttonTextColor,
      borderRadius: '15px',
      buttonBorderWidth: styles.buttonBorder ? `1px` : 'none',
      buttonBorderColor: styles.buttonBorder
        ? styles.buttonBorderColor
        : 'none',
      buttonSize: 'btn btn-sm px-4 py-2',
      fontSize: Number(styles.memberCountTextSize),
      btnHoverColor: styles.buttonColorWhenHovering,
      btnTextHoverColor: styles.buttonTextColorWhenHovering
    };

    this.buttonLoginOptions = {
      primaryColor: 'transparent',
      secondaryColor: styles.secondaryColor,
      buttonText: 'ENTRAR',
      buttonTextColor: styles.buttonTextColorEnter,
      borderRadius: '15px',
      buttonBorderWidth: styles.buttonBorderEnter ? `1px` : 'none',
      buttonBorderColor: styles.buttonBorderEnter
        ? styles.buttonBorderColorEnter
        : 'none',
      buttonSize: 'btn btn-sm px-4 py-2',
      fontSize: Number(styles.memberCountTextSize),
      btnHoverColor: styles.buttonColorWhenHoveringEnter,
      btnTextHoverColor: styles.buttonTextColorWhenHoveringEnter
    };
  }

  orderByUnread(notificationsList: Notification[]): Notification[] {
    return notificationsList.sort(function (x) {
      return x.isViewed === true ? 0 : x ? -1 : 1;
    });
  }

  markAllNotificationsAsRead() {
    const memberId = this.userInfo.id;

    // Using concatMap to process one request at a time in order
    from(this.notifications)
      .pipe(
        filter((notification) => !notification.isViewed),
        concatMap((notification) =>
          this.notificationService.setNotificationViwed(
            notification.id,
            memberId
          )
        )
      )
      .subscribe({
        complete: () => {
          this.notifications = this.setNotificationArrRead(this.notifications);

          //Atualizar lista de notificações
          this.updateNotificationList(this.notifications);

          this.alertService.showAlert(
            AlertType.SUCCESS,
            'Todas notificações foram marcadas como lidas!'
          );
        },
      });
  }

  setNotificationArrRead(notifications: Notification[]): Notification[] {
    if (!notifications.length) {
      return [];
    }

    return notifications.map((notification) => {
      notification.isViewed = true;
      return notification;
    });
  }

  updateNotificationList(notifications: Notification[]) {
    if (this.currentUrl === '/lista-notificacoes') {
      this.setFromHeader = true;
      this.notificationService.setUpdateNotificationSubject(notifications);
    }
  }

  async navigationLogo() {
    this.resetNavSelection(this.currentUrl, true);

    if (this.isLoggedIn()) {
      this.goToDashboard();
    } else if (this.isDependent()) {
      this.goToDashboardDependent();
    }
    else {
      await this.goToHome();

      if (this.currentUrl === '/') {
        this.scrollToSection('main');
      } else if (
        this.currentUrl.includes('login') ||
        this.currentUrl === '/cadastro-socio' ||
        this.currentUrl === '/faq'
      ) {
        this.scrollToSection('exclusivo');
      }
    }
  }

  goToDashboard() {
    this.router.navigate(['/dashboard']);
  }

  goToDashboardDependent() {
    this.router.navigate(['/dashboard-dependente']);
  }

  async navigationHeaderItems(menuItem: string) {
    if (
      (this.isLoggedIn() && this.userBlocked) ||
      (this.activeSections() && !this.activeSections()[menuItem])
    ) {
      if (this.isLoggedIn()) {
        return console.log('Acesso negado!');
      }
    }

    if (menuItem == 'facial') {
      this.router.navigate(['/termo-facial']);
    }

    if (menuItem == 'leao') {
      window.open(
        'https://clubeleaodevantagens.com.br/?leaodevantagens=3262d5a5cc6d8d1666a2a4a6bab9f06e',
        '_blank'
      );
      return;
    }

    this.selectedMenuItem = menuItem;

    if (this.isLoggedIn()) {
      this.headerLinksNavigation(menuItem);
    } else {
      await this.goToHome();
      this.scrollToSection(menuItem);
    }
  }

  async goToHome() {
    if (this.currentUrl !== '/') {
      this.router.navigate(['/']);
    }
  }

  private headerLinksNavigation(menuItem: string): void {
    switch (menuItem) {
      case 'ingressos':
        this.router.navigate(['/check-in']);
        break;
      case 'experiencias':
        this.router.navigate(['/experiencias']);
        break;
      case 'parceiros':
        let linkPartners = localStorage.getItem('linkPartners');
        if (linkPartners) {
          linkPartners = linkPartners.trim();

          if (!linkPartners.startsWith('http://') && !linkPartners.startsWith('https://')) {
            linkPartners = 'https://' + linkPartners;
          }

          window.open(linkPartners, '_blank');
        } else {
          this.router.navigate(['/parcerias']);
        }
        break;
      case 'transparencia':
        this.router.navigate(['/transparencia']);
        break;
      case 'ranking':
        this.router.navigate(['/ranking-de-socios']);
        break;
      case 'cartao-todos':
        this.router.navigate(['/cartao-todos']);
        break;
      case 'facial':
        this.router.navigate(['/termo-facial']);
        break;
      case 'exclusivo':
        this.router.navigate(['/conteudo-exclusivo']);
        break;
      default:
        break;
    }
  }

  private scrollToSection(menuItem: string) {
    const element = document.getElementById(
      menuItem.replace(/\s+/g, '-').toLowerCase()
    );
    if (element) {
      const elementRect = element.getBoundingClientRect();
      const offsetPosition =
        elementRect.top +
        window.scrollY -
        (window.innerHeight - elementRect.height) / 2;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }

  getActiveSections() {
    this.activeSectionsService.getActiveSections().subscribe({
      next: (res: any) => {
        const url = window.location.href.toLowerCase();
        const hasVitoria = url.includes('vitoria');
        res.sections.leao = hasVitoria;

        localStorage.setItem('activeSections', JSON.stringify(res.sections));
        this.activeSections.set(res.sections);
      },
      error: (err: any) => {
        console.error('Erro ao obter activeSections:', err);
        const storedSections = localStorage.getItem('activeSections');
        if (storedSections) {
          this.activeSections.set(JSON.parse(storedSections));
        }
      },
      complete: () => {
        this.activeSectionsSearched = true;
      },
    });
  }

  ngOnDestroy(): void {
    // Emit a signal to unsubscribe from the observable
    this._destroy$.next();
    this._destroy$.complete();
  }
}
